// NotFound.tsx
import React from "react";
import { Link } from "react-router-dom";
import { PATH_TO_TITLE_MAPPING } from "@/constants/constants";
import { Button } from "@/components/common/button";

const NotFound: React.FC = () => {
  document.title = PATH_TO_TITLE_MAPPING["*"];

  return (
    <section className="text-foreground mt-24 flex flex-col items-center justify-center gap-6 p-4 pt-0 text-center md:mt-28 lg:p-6 lg:pt-0">
      <div className="space-y-1">
        <h2 className="text-4xl font-bold">404</h2>
        <p className="text-foreground text-lg">Page not found</p>
      </div>
      <Link to="/">
        <Button>Go to Homepage</Button>
      </Link>
    </section>
  );
};

export default NotFound;
